import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '../../../../services/user.service';
import { loginResponse } from '../../../../model/common/common.model';
import _ from 'lodash';
import { AdministratorService } from '../../../../services/administrator.service';
import { MessageService } from 'primeng/api';
import { LoaderComponent } from '../../../loader/loader.component';

@Component({
  selector: 'app-create-menu',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent],
  templateUrl: './create-menu.component.html',
  styleUrl: './create-menu.component.scss'
})
export class CreateMenuComponent implements OnInit {

  isMenuDropdown: boolean = false;

  selectedMenu: string = '';
  isMenuDisabled: boolean = false;
  menuId: any;
  loader: boolean = false;

  userInfo:loginResponse | undefined ;

  constructor(private route: Router, private userService: UserService, private administratorService: AdministratorService , private messageService:MessageService) {
  }

  menuOptions: any[] = [];
  submitted: boolean = false;
  menuForm = new FormGroup({
    Menu: new FormControl('', Validators.required),
    selectMenuDropdown: new FormControl(''),
    subMenu: new FormControl('', Validators.required),
    // selectMenu: new FormControl(''),
    Active: new FormControl(true),
    isMenuDropdown: new FormControl(false)
  });

  ngOnInit(): void {
    document.title = 'Create Menu';
    this.getMenu();
  }

  saveMenu() {
    throw new Error('Method not implemented.');
  }

  cancel() {
    this.route.navigate(['/home']);
  }

  // toggleMenuState() {
  //   this.isMenuDropdown = !this.isMenuDropdown;
  // }

  
  getMenu() {
    
    this.administratorService.GetAllMenu().subscribe(
      (data: any) => {
        if (data) {
          this.menuOptions = data;
          // console.log(data);
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );

  }

  createMenu(){
    if(this.menuForm.controls.isMenuDropdown.value===true && this.menuId && this.menuForm.controls.subMenu.value){
      this.createSubMenu();
      return;
    }
    this.submitted = true;
    if(this.menuForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' });
      return;
    }
    this.loader = true;
    const a:any = this.menuForm.controls.Menu.value;
    const key = a.replace(/\s/g, '').toLowerCase();

    const data = {
      title: this.menuForm.controls.Menu.value,
      key: key,
      isActive: true,
      subMenu: []
    };
    
    this.administratorService.AddMenu(data).subscribe({
      next: (response: any) => {
        try {
          this.menuId = response;
          // console.log(response);
          this.createSubMenu();
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully created.' });
        } catch (e) {
          console.log(response);
          this.loader = false;
        }
      },
      error: error => {
        console.log(error);
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Failed to Create', detail: error.error });
      }
    });
    
  }


  createSubMenu(){
    const a:any = this.menuForm.controls.subMenu.value;
    const key = a.replace(/\s/g, '').toLowerCase();
    const  CreatedBy = (localStorage.getItem('username'));
    this.loader = true;
    const data = {
      title: this.menuForm.controls.subMenu.value,
      key: key,
      createdby: CreatedBy,
      isActive: true,
    };
    
    this.administratorService.AddSubMenu(this.menuId,data).subscribe({
      next: (response: any) => {
        try {
          // console.log(response);
          if(this.menuForm.controls.isMenuDropdown.value===true){
            this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
            this.loader = false;
          }
          this.loader = false;
        } catch (e) {
          console.log(response);
          this.loader = false;
        }
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    });
    
  }



  reset(){
    this.menuForm.reset();
    // this.menuForm.controls.isActive.setValue(true);
  }

  setMenu(data:any){
    if (data.value) {
      this.menuForm.controls.Menu.setValue(_.toString(data.value.name));
      this.menuId = data.value.menuId;
    }
  }
  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.moveToNextField(event);
    }
  }

  moveToNextField(event: KeyboardEvent) {
    const inputs = Array.from(document.querySelectorAll('input')) as HTMLInputElement[];
    const index = inputs.indexOf(event.target as HTMLInputElement);
    if (index > -1 && index < inputs.length - 1) {
      (inputs[index + 1] as HTMLInputElement).focus();
    }
  }
}
